const APPROVAL_REASON_PUNCHOUT = 'punchout';
const APPROVAL_REASON_GIFT_CARD = 'gift-card';
const REQUIRED = 'required';
const APPROVAL_REQUIRED = 'approval_required';
const PENDING_APPROVAL = 'pending_approval';
const REJECTED = 'rejected';

const APPROVAL_STATUSES = {
  [REQUIRED]: REQUIRED,
  [APPROVAL_REQUIRED]: APPROVAL_REQUIRED,
  [PENDING_APPROVAL]: PENDING_APPROVAL,
  [REJECTED]: REJECTED
};

export { APPROVAL_REASON_GIFT_CARD, APPROVAL_REASON_PUNCHOUT, APPROVAL_STATUSES };
